module.exports = __webpack_public_path__ + "static/media/emotion2.189c287f.webp";